import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));
export default function MinorSelect(props) {
  const initialMenu = props.labelName;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [minor, setMinor] = React.useState(props.originalMinor);
  const [minors, setMinors] = React.useState(props.minors);
  React.useEffect(() => {
    setMinors(props.minors);
  }, [props.minors])
  
  const handleChange = (event) => {
    setMinor(event.target.value);
    props.setMinor(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div style={{width:'100%'}}>
      <FormControl className={classes.formControl} style={{width:'100%'}}>

        <InputLabel id="demo-controlled-open-select-label">
          <div style={{width: '100%', textAlign: 'center'}}>
            {initialMenu}
          </div>
        </InputLabel>
        <Select
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={minor}
          onChange={handleChange}
          style={{width:'100%'}}
        >
          <MenuItem style={{width: '100%'}} value="">
            <em style={{width: '100%', textAlign: 'center'}}>None</em>
          </MenuItem>
          {
            minors.map(minor =>
                <MenuItem style={{width:'100%'}} value={minor.minor_code}>
                    <div style={{width: '100%', textAlign: 'center'}}>
                        {minor.name}
                    </div>
                </MenuItem>
            )
          }
        </Select>
      </FormControl>
    </div>
  );
}